import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../../../Components/common/Loading';
import NoDataFound from '../../../Components/common/NoDataFound';
import OrderCard from '../../../Components/common/OrderCard';
import OrderDetailsPopup from '../../../Components/common/OrderDetailsPopup';
import TransitionLoader from '../../../Components/common/TransitionLoader';
import AppConstant from '../../../constant/AppConstant';
import { fetchIRDOrderList } from '../../../store/slices/ird/irdSlice';
import { getOrderSource } from '../../../services/apiService';
import { notification } from 'antd';
import { commonSelector } from '../../../store/slices/common/commonSlice';
import { fetchCancelReason } from '../../../helper/_commonHelper';

const Accepted = (props) => {
    const [showItemPopup, setShowItemPopup] = useState(false);
    const [detailedViewItem, setDetailedViewItem] = useState({});
    const [showTransitionLoader, setShowTransitionLoader] = useState(false);
    const { data, loading, hasNotification, updateOrderByType } = props;
    const dispatch = useDispatch();
    const authtype = getOrderSource();

    const [api, contextHolder] = notification.useNotification();
    const openNotificationWithIcon = (type, title = '', msg = '') => {
        api[type]({
            message: (title = ''),
            description: msg,
        });
    };
    const {availableServices= {}}=useSelector(commonSelector);
    const [cancelReason, setCancelReason] = useState();

    const isCancellationAllowed = availableServices?.order_cancellation_service;

    useEffect(() => {
        isCancellationAllowed && fetchCancelReason(setCancelReason);
    }, [isCancellationAllowed]);

    const handleClosePopup = () => {
        setShowItemPopup(false);
        setDetailedViewItem({});
    };
    const handleShowPopup = (item) => {
        setShowItemPopup(true);
        setDetailedViewItem(item);
    };

    const handleClearSave = async (item) => {
        try {
            setShowTransitionLoader(true);
            let response = await axios.put(
                AppConstant.config.appBaseUrl +
                    `/${authtype}/order/dispatch/` +
                    item.order_detail.order_id
            );
            if (response.status === 202) {
                const msg = response.data.message || '';
                openNotificationWithIcon('success', '', msg);

                setTimeout(() => {
                    dispatch(fetchIRDOrderList());
                }, 1000);
            }
        } catch (error) {
        } finally {
            setTimeout(() => {
                setShowTransitionLoader(false);
            }, 1000);
        }
    };

    const compChange = async (value, item) => {
        try {
            let response = await axios.put(
                AppConstant.config.appBaseUrl +
                    `/common/order/complementary/${value}/` +
                    item.order_detail.order_id
            );
            if (response.status === 200) {
                let msg =
                    value === 'enable'
                        ? 'Meal marked as complimentary!'
                        : 'Meal unmarked as complimentary!';
                openNotificationWithIcon('success', '', msg);
            }
        } catch (error) {
            console.log('error', error);
        }
    };
    return (
        <section className='order-list-container'>
            {contextHolder}

            {data.length === 0 ? (
                <div className='home-order-screen no-data'>
                    <NoDataFound />
                </div>
            ) : (
                <div className='home-screen'>
                    {data.length > 0
                        ? data.map((item, index) => {
                              return (
                                  <OrderCard
                                      tabType={'InKitchen'}
                                      ServiceName={'IRD'}
                                      OrderType={'In Kitchen'}
                                      key={item.id}
                                      item={item}
                                      viewDetails={() => handleShowPopup(item)}
                                      footerBtn={() => handleClearSave(item)}
                                      btnTitle={'Dispatch'}
                                      timerTime={
                                          item?.order_detail?.accepted_at
                                      }
                                      complimentaryChange={compChange}
                                      isCancellationAllowed={
                                          isCancellationAllowed
                                      }
                                      cancelReason={cancelReason}
                                      setCancelReason={setCancelReason}
                                  />
                              );
                          })
                        : null}
                </div>
            )}
            {showItemPopup && (
                <OrderDetailsPopup
                    open={showItemPopup}
                    close={handleClosePopup}
                    item={detailedViewItem}
                />
            )}
            {showTransitionLoader && (
                <TransitionLoader
                    previousStage={'Accepted'}
                    newStage={'Dispatched'}
                />
            )}
        </section>
    );
};

export default Accepted;
